import { Metadata } from 'next';

import { env } from '@/env';

export const appConfig = {
  title: env.NEXT_PUBLIC_APP_NAME,
  description: `${env.NEXT_PUBLIC_APP_NAME} is a web application that allows you to search for keywords and their related information.`,
  keywords:
    'keywords, digger, search, keywords digger, digger keywords, rank smith',
  logo: '/logo/main.png',
  logoDark: '/logo/dark.png',
  appUrl: env.NEXT_PUBLIC_APP_URL,
  email: {
    support: 'support@seomaven.ai',
    sender: 'support@seomaven.ai',
    adminNotifier: 'notifications@seomaven.ai',
    admin: 'support@seomaven.ai',
  },
  defaultPassword: 'DigTrig1!',
  aiModels: {
    imageGeneration: 'google/gemini-2.5-flash-image',
  },
  // name should match the plugin_feature_enum in the database
  plugins: {
    wordpress_ajax_bridge: {
      slug: 'wordpress_ajax_bridge',
      version: 1.12,
      url: '/automation-ajax-bridge.zip',
      name: 'WordPress Automation AJAX Bridge',
      downloadName: 'automation-ajax-bridge.zip',
      tutorialUrl: '',
    },
  },
} as const;

interface MetadataOptions {
  ogImageUrl?: string;
  pageTitle?: string;
  description?: string;
}

export default function getMetadata(options?: MetadataOptions): Metadata {
  const { ogImageUrl, pageTitle, description } = options || {};

  const baseMetadata: Metadata = {
    title: pageTitle || appConfig.title,
    description: description || appConfig.description,
  };

  // Only include openGraph and twitter if ogImageUrl exists
  if (ogImageUrl) {
    return {
      ...baseMetadata,
      openGraph: {
        title: pageTitle || appConfig.title,
        description: description || appConfig.description,
        siteName: appConfig.title,
        images: [
          {
            url: ogImageUrl,
            width: 1200,
            height: 630,
            alt: `Invitation to ${appConfig.title}`,
          },
        ],
        type: 'website',
      },
      twitter: {
        card: 'summary_large_image',
        title: pageTitle || appConfig.title,
        description: description || appConfig.description,
        images: [ogImageUrl],
      },
    };
  }

  return baseMetadata;
}
